import { Component, OnInit } from '@angular/core';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { Provider } from '../../../shared/models/provider-search/provider';
import { AhsTranslationService } from '@nx-ahs/base-translate';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal/confirm-modal.component';
import { PopoverController } from '@ionic/angular';

@Component({
	selector: 'nx-ahs-provider-search-result-list',
	templateUrl: './provider-search-result-list.component.html',
	styleUrls: ['./provider-search-result-list.component.scss'],
	standalone: false
})
export class ProviderSearchResultListComponent extends AHSTripettoComponent implements OnInit {
	public data: Provider[] = null;

	constructor(
		private ahsTranslationService: AhsTranslationService,
		private popoverController: PopoverController
	) {
		super();
	}

	ngOnInit(): void {
		const dataTest = this.scriptJsonStr;

		if (dataTest) {
			this.data = JSON.parse(dataTest);
		}

		// updateScriptData method call would go here if needed
	}

	// updateScriptData(){

	// }

	public async presentSpecialtiesModal(specialties: string[], enabled: boolean) {
		if (enabled) {
			const sortedSpecialties = specialties.sort();
			let message = '';

			message += this.generateList(sortedSpecialties);

			const pop = await this.popoverController.create({
				backdropDismiss: false,
				component: ConfirmModalComponent,
				mode: 'ios',
				componentProps: {
					title: 'Specialties',
					message: message,
					justOK: true,
					messageIsHTML: true
				},
				cssClass: 'acct-confirm-popover'
			});

			await pop.present();
			return pop.onDidDismiss();
		}
	}

	private generateList(items: any[]): string {
		let message = '';

		if (items.length > 0) {
			message += `<div>`;
			items.forEach((specialty) => {
				message += `<div class="specialty-popup-wrapper">
                            <div class="specialty-popup-name">${specialty}</div>
                        </div>`;
			});
			message += `</div>`;
		}

		return message;
	}
}
